import { t } from '@lingui/macro';
import isEmpty from 'lodash/isEmpty';
import React, { memo } from 'react';
import CustomChart from '../components/CustomChart/CustomChart';
import { CHART_DATE_FORMAT } from '../utils';

// Same order the endpoint returns the series in: positive, neutral, negative —
// matching the customer_sentiment pie chart's colours.
const datasetsOption = [
  { borderColor: '#3db783', backgroundColor: '#3db783' },
  { borderColor: '#f9b903', backgroundColor: '#f9b903' },
  { borderColor: '#e53c68', backgroundColor: '#e53c68' },
];

const getSeriesLabels = () => [t`Tích cực`, t`Trung lập`, t`Tiêu cực`];

// maintainAspectRatio: false keeps this card the same height as the pie charts
// in the customer group (they all set it too).
const getOption = () => ({
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    xAxes: [
      {
        scaleLabel: {
          labelString: t`Thời gian`,
        },
        // No min/max: let the axis fit the returned days so every point gets a
        // tick label, instead of stretching across the whole selected range.
        type: 'time',
        time: {
          unit: 'day',
          tooltipFormat: CHART_DATE_FORMAT,
          displayFormats: {
            day: 'DD/MM',
          },
        },
        ticks: {
          autoSkip: true,
          maxRotation: 0,
          maxTicksLimit: 15,
        },
      },
    ],
    yAxes: [
      {
        scaleLabel: {
          labelString: t`Số khách hàng`,
        },
        ticks: {
          suggestedMin: 0,
          beginAtZero: true,
          callback: function (value) {
            if (value % 1 === 0) return value;
          },
        },
      },
    ],
  },
  tooltips: {
    mode: 'index',
    callbacks: {
      label: function (tooltipItem, data) {
        const value = data?.datasets?.[tooltipItem.datasetIndex]?.data?.[tooltipItem.index] ?? 0;
        const label = data?.datasets?.[tooltipItem.datasetIndex]?.label ?? '';
        return `${label}: ${value}`;
      },
    },
  },
});

const normalizedData = (data) => {
  if (isEmpty(data) || !data?.datasets) return {};

  const seriesLabels = getSeriesLabels();

  return {
    labels: (data.labels || []).map((label) => new Date(label * 1000)),
    datasets: data.datasets.map((item, index) => ({
      fill: false,
      // Smooth curves without overshooting past the real data points (counts
      // never dip below 0). Use `lineTension: 0` here for straight segments.
      cubicInterpolationMode: 'monotone',
      pointRadius: 2,
      borderWidth: 2,
      ...datasetsOption[index],
      data: item.data ?? [],
      label: seriesLabels[index] ?? item.label,
    })),
  };
};

const getColumns = () => [
  { Header: t`Thời gian`, width: 100, accessor: 'x' },
  { Header: t`Số khách hàng`, width: 100, accessor: 'y' },
];

const CustomerSentimentByDay = (props) => {
  return (
    <CustomChart
      normalizedData={normalizedData}
      columns={getColumns()}
      getOption={getOption}
      {...props}
    />
  );
};

export default memo(CustomerSentimentByDay);
